import TextBoxSymbol from "../classes/TextBox";

export const textBoxes = [
  new TextBoxSymbol({
    alias: "textbox-node",
    label: "Caja de texto",
  }),
];
